import { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import { Navigation } from '@/components/layout/navigation'
import { AuthGuard } from '@/components/auth/auth-guard'
import { useAuthStore } from '@/stores/auth-store'
import { ThemeController } from '@/components/theme-controller'
import { ToastViewport } from '@/components/ui/use-toast'

// Import page components
import HomePage from '@/pages/HomePage'
import WeekMenuPage from '@/pages/WeekMenuPage'
import MenuPoolPage from '@/pages/MenuPoolPage'
import RecipesPage from '@/pages/RecipesPage'
import RecipeDetailPage from '@/pages/RecipeDetailPage'
import NewRecipePage from '@/pages/NewRecipePage'
import EditRecipePage from '@/pages/EditRecipePage'
import SearchPage from '@/pages/SearchPage'
import SettingsPage from '@/pages/SettingsPage'
import ProfilePage from '@/pages/ProfilePage'
import NotFoundPage from '@/pages/NotFoundPage'

// Import household features
import HouseholdInvitePage from '@/pages/HouseholdInvitePage'

// Import meal planning features
import MealPlanningPage from '@/pages/MealPlanningPage'

// Import auth pages
import LoginPage from '@/pages/LoginPage'
import RegisterPage from '@/pages/RegisterPage'
import { ErrorBoundary } from '@/components/error-boundary'

function App() {
  const initialize = useAuthStore((state) => state.initialize)

  useEffect(() => {
    void initialize()
  }, [initialize])

  return (
    <ErrorBoundary>
      <ThemeController />
      <ToastViewport />
      <div className="min-h-screen">
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        
        {/* Protected routes */}
        <Route path="/*" element={
          <AuthGuard>
            <Navigation />
            <main className="min-h-screen">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/weekmenu" element={<WeekMenuPage />} />
                <Route path="/weekmenu/pool" element={<MenuPoolPage />} />
                <Route path="/recepten" element={<RecipesPage />} />
                <Route path="/recepten/nieuw" element={<NewRecipePage />} />
                <Route path="/recepten/:id" element={<RecipeDetailPage />} />
                <Route path="/recepten/:id/bewerken" element={<EditRecipePage />} />
                <Route path="/profiel/bewerken" element={<ProfilePage />} />
                <Route path="/uitnodiging/:inviteCode" element={<HouseholdInvitePage />} />
                <Route path="/weekplanning" element={<MealPlanningPage />} />
                <Route path="/zoeken" element={<SearchPage />} />
                <Route path="/instellingen" element={<SettingsPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </main>
          </AuthGuard>
        } />
      </Routes>
      </div>
    </ErrorBoundary>
  )
}

export default App
